import { useEffect, useState } from 'react';
import { fetchUserHasPermission } from '../APIs/usersAPIs';

export const useHasPermission = (action) => {
  const [hasPermission, setHasPermission] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPermission = async () => {
      const token = localStorage.getItem('token');

      if (!token) {
        setHasPermission(false);
        setLoading(false);
        return;
      }

      try {
        const result = await fetchUserHasPermission(action, token);
        setHasPermission(result);
      } catch (error) {
        console.error('Error checking permission:', error);
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, [action]);

  return { hasPermission, loading };
};

export const validatePassword = (password) => {
  return {
    hasUpperCase: /[A-Z]/.test(password),
    hasLowerCase: /[a-z]/.test(password),
    hasNumber: /\d/.test(password),
    hasSpecialChar: /[!_@#$%^&*(),.?":{}|<>]/.test(password),
    hasLength: password.length >= 8,
  };
};

export const localizeDates = (dateStr) => {
  const date = new Date(dateStr);

  const formatter = new Intl.DateTimeFormat('ar-EG', {
    dateStyle: 'full',
    timeStyle: 'short',
  });

  const localized = formatter.format(date);
  return localized;
};

export const getEnvironment = () => {
  const environment = import.meta.env.VITE_CURRENT_ENV;
  if (environment === 'prod') return 'production';
  else if (environment === 'stag') return 'staging';
  else if (environment === 'dev') return 'development';
  else return 'development';
};
